var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembersHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2713 21.2942L33.6166 7.11998L29.8253 6.76011",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2049 6.77026H7.80683C7.32523 6.77026 6.93481 7.16068 6.93481 7.64228V16.5804",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8252 8.40533V20.9406",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.205 16.2807V4.45396C10.205 3.98741 10.5954 3.60919 11.077 3.60919H28.9533C29.4349 3.60919 29.8253 3.98741 29.8253 4.45396V19.6597C29.8253 20.0712 29.5216 20.414 29.1195 20.4892",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.475 11.1304H26.5552",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.475 7.86029H26.5552",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.475 14.4004H26.5552",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.475 17.6705H26.5552",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84483 16.5805H12.385L15.655 20.5253H29.8253C31.6783 20.5253 33.0953 21.8074 33.0953 23.484V34.3323C33.0953 36.0088 31.6783 37.2909 29.8253 37.2909H6.93485C5.08182 37.2909 3.66479 36.0088 3.66479 34.3323V18.5529C3.66479 17.4681 4.64581 16.5805 5.84483 16.5805Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.039 29.6606H6.28086C6.04006 29.6606 5.84485 29.8559 5.84485 30.0967V32.4947C5.84485 32.7355 6.04006 32.9307 6.28086 32.9307H13.039C13.2798 32.9307 13.475 32.7355 13.475 32.4947V30.0967C13.475 29.8559 13.2798 29.6606 13.039 29.6606Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersHub);
export default __webpack_public_path__ + "static/media/MembersHub.876a1e74efd92fdb2db6739560789167.svg";
export { ForwardRef as ReactComponent };